import axios from 'axios';
import {
	GET_ALL_USERS_SUCCESS,
	GET_ALL_USERS_FAIL,
	CREATE_USER_SUCCESS,
	CREATE_USER_FAIL,
	SET_ALERT,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_FAIL,
} from './index';
const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

export const getAllUsers =
	(
		offset: number = 0,
		name = '',
		email = '',
		role = '',
		status = '',
		facility = ''
	) =>
	async (dispatch: any) => {
		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};

		const body = { name, email, role, status, facility };

		try {
			const response = await axios.post(
				`${BASE_URL}/api/get-all-users?offset=${offset}`,
				body,
				config
			);
			dispatch({ type: GET_ALL_USERS_SUCCESS, payload: response.data });
			return Promise.resolve();
		} catch (e) {
			dispatch({
				type: SET_ALERT,
				payload: {
					message: 'Failed to fetch users',
					status: 'error',
				},
			});
			dispatch({ type: GET_ALL_USERS_FAIL });
			return Promise.reject(e);
		}
	};

export const createUser =
	({ name, email, password, is_admin, fac_id }) =>
	async (dispatch: any) => {
		// var is_admin = role == 'admin' ? 1 : 0;

		const config = {
			headers: {
				'x-auth-token': localStorage.getItem('x-auth-token'),
			},
		};

		try {
			const response = await axios.post(
				BASE_URL + `/api/create-user`,
				{ name, email, password, is_admin, fac_id },
				config
			);
			// console.log(response.data);
			dispatch({ type: CREATE_USER_SUCCESS, payload: response.data });
		} catch (e) {
			dispatch({ type: CREATE_USER_FAIL });
			dispatch({
				type: SET_ALERT,
				payload: { message: e.response?.data?.error || 'Failed to create user', status: 'error' },
			});
			throw e;
		}
	};

export const resetUserPassword = (userId, password) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		await axios.put(`${BASE_URL}/api/reset-password/${userId}`, { password }, config);
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Password reset successfully', status: 'success' },
		});
		return Promise.resolve();
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to reset password',
				status: 'error',
			},
		});
		return Promise.reject(e);
	}
};

export const changePassword = (currentPassword, newPassword) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		await axios.put(`${BASE_URL}/api/change-password`, { currentPassword, newPassword }, config);
		dispatch({
			type: SET_ALERT,
			payload: { message: 'Password changed successfully', status: 'success' },
		});
		return Promise.resolve();
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to change password',
				status: 'error',
			},
		});
		return Promise.reject(e);
	}
};

export const updateUser = (userId, userData) => async (dispatch: any) => {
	const config = {
		headers: {
			'x-auth-token': localStorage.getItem('x-auth-token'),
		},
	};
	try {
		const response = await axios.put(
			`${BASE_URL}/api/update-user/${userId}`,
			userData,
			config
		);
		dispatch({ type: UPDATE_USER_SUCCESS, payload: response.data });
		return Promise.resolve();
	} catch (e) {
		dispatch({
			type: SET_ALERT,
			payload: {
				message: e.response?.data?.error || 'Failed to update user',
				status: 'error',
			},
		});
		dispatch({ type: UPDATE_USER_FAIL });
		return Promise.reject(e);
	}
};
